import { render, staticRenderFns } from "./LoginHeader.vue?vue&type=template&id=0cec89b7&scoped=true&"
import script from "./LoginHeader.vue?vue&type=script&lang=js&"
export * from "./LoginHeader.vue?vue&type=script&lang=js&"
import style0 from "./LoginHeader.vue?vue&type=style&index=0&id=0cec89b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cec89b7",
  null
  
)

export default component.exports